import { captureException, captureMessage } from "@sentry/react";

import { LOGLEVEL, CLIENT_START_ERROR_CODE, SERVER_END_ERROR_CODE } from "constants/sentry";

export const reportExceptionToSentry = (error, extraInfo = {}) => {
  if (Object.keys(extraInfo).length !== 0) {
    captureException(error, extraInfo);
  }
  captureException(error);
}

export const reportHttpErrorToSentry = (error) => {
  if (error.status && (error.status >= CLIENT_START_ERROR_CODE && error.status <= SERVER_END_ERROR_CODE)) {
    let sentryError = `API ${error.url} ${error.status}`;
    captureMessage(sentryError, { tags: { APIError: true, level: LOGLEVEL.INFO }, extra: { error }, fingerprint: [error.url, error.status] });
  } else {
    reportExceptionToSentry(error, { tags: { APIError: false, level: LOGLEVEL.ERROR }, extra: { error }, fingerprint: [error.url, error.status] });
  }
}